import React from 'react';
import TextComponent from 'shared/components/TextComponent';
import classnames from 'classnames';

const PartNumber = (props) => {
  const name = 'part_number';

  const {
    label,
    inputId,
    required,
    groupName,
    children,
    onChangeParameter,
    errorMessage,
    tooltip,
    disabled,
    className,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);
  const { parameters } = props;

  return (
    <TextComponent
      label={label}
      name={name}
      inputId={inputId}
      value={parameters[name] || ''}
      required={required}
      onChange={onChange}
      tooltip={tooltip}
      groupName={groupName}
      errorMessage={errorMessage}
      className={classnames('part-number', className)}
      disabled={disabled}>
      {children}
    </TextComponent>
  );
};

PartNumber.defaultProps = {
  inputId: 'part-number',
  label: Spree.translations.parameters.part_number,
  tooltip: Spree.helpForParameters.part_number,
};

export default PartNumber;
